import { message } from "antd";
import { useEffect } from "react";
import { AUDIENCE_CONSTANTS } from "../../../shared/constants/audience.constants";
import type { AudienceContextValue } from "../types";

/**
 * Hook to handle UI effects for audience creation
 */
export const useCreateAudienceEffect = (
	mutation: AudienceContextValue["hooks"]["createAudienceMutation"],
	callbacks?: {
		onSuccess?: () => void;
		onError?: (error: any) => void;
	},
) => {
	useEffect(() => {
		// Handle success state
		if (mutation.isSuccess) {
			message.success(AUDIENCE_CONSTANTS.SUCCESS_CREATE_MSG);
			callbacks?.onSuccess?.();
			// Reset mutation state to prevent stale success state on next modal open
			mutation.reset();
		}

		// Handle error state
		if (mutation.isError) {
			if (
				mutation.error?.response?.status ===
				AUDIENCE_CONSTANTS.RESPONSE_CONFLICT_ERROR
			) {
				message.warning(AUDIENCE_CONSTANTS.WARN_AUDIENCE_NAME_EXIST_MSG);
			} else if (
				mutation.error?.response?.status ===
				AUDIENCE_CONSTANTS.RESPONSE_PERMISSION_ERROR
			) {
				message.error("権限がありません");
			} else if (
				mutation.error?.response?.status ===
				AUDIENCE_CONSTANTS.RESPONSE_SESSION_ERROR
			) {
				message.warning({
					content: AUDIENCE_CONSTANTS.ERROR_SESSION_MSG,
					key: "MESSAGE_SESSION_ERROR_KEY",
				});
			} else {
				message.error({
					content: AUDIENCE_CONSTANTS.ERROR_SYSTEM_MSG,
					key: "MESSAGE_SYSTEM_ERROR_KEY",
				});
			}
			callbacks?.onError?.(mutation.error);
			// Reset mutation state to clear error state
			mutation.reset();
		}
	}, [mutation.isSuccess, mutation.isError, callbacks]);
};
